'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useCallback, useState } from 'react';

import cx from 'clsx';
import NextImage from 'next/image';
import PropTypes from 'prop-types';

import PaginationDots from 'components/ui/PaginationDots';

import styles from './Slideshow.module.scss';

const Slideshow = ({ firstBlock, images, className, theme = 'light' }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [previousIndex, setPreviousIndex] = useState(0);
    const validImages = images?.filter(img => !!img.url) ?? [];
    const isSlideshow = validImages.length > 1;

    const next = useCallback(() => {
        setActiveIndex(prevIndex => {
            setPreviousIndex(prevIndex);
            return prevIndex < validImages.length - 1 ? prevIndex + 1 : 0;
        });
    }, [validImages.length]);

    const handleImageClick = () => {
        next();
    };

    return (
        <div
            className={cx(styles.root, className, styles[theme], {
                [styles.isSlideshow]: isSlideshow,
            })}
        >
            <div
                className={styles.imageWrapper}
                onClick={isSlideshow ? handleImageClick : null}
            >
                {validImages.map((image, idx) => {
                    return (
                        <NextImage
                            key={idx}
                            className={cx(styles.image, {
                                [styles.isActive]: activeIndex === idx,
                                [styles.isPrevious]: previousIndex === idx,
                            })}
                            src={image.url}
                            alt={image?.description || ''}
                            width={image?.width}
                            height={image?.height}
                            sizes="(max-width: 768px) 100vw, 50vw"
                            {...(firstBlock && idx === 0
                                ? { fetchPriority: 'high' }
                                : {})}
                            priority
                        />
                    );
                })}
            </div>
            {isSlideshow && (
                <nav className={styles.nav}>
                    <PaginationDots
                        pill
                        className={styles.dots}
                        count={validImages.length}
                        activeIndex={activeIndex}
                        onSelect={idx => {
                            setPreviousIndex(activeIndex);
                            setActiveIndex(idx);
                        }}
                    />
                </nav>
            )}
        </div>
    );
};

Slideshow.propTypes = {
    images: PropTypes.array,
    className: PropTypes.string,
    theme: PropTypes.string,
};

export default Slideshow;
